// "What's new" — the release notes people see once, after a release, and can reopen from the
// profile menu. THE list and THE rule for when it opens.
//
// Next release: add its items, bump WHATS_NEW_RELEASE.id and publishedAt — everyone whose
// account existed before publishedAt sees the dialog once more. Every title/body key must exist
// in both languages (TranslationContext); the unit test checks it.

export const WHATS_NEW_RELEASE = {
  id: '2026-09',
  /** Accounts created after this never used the previous version, so nothing is new to them. */
  publishedAt: '2026-09-24T20:00:00Z',
};

/** users.preferences key holding the id of the release notes this person has dismissed. */
export const WHATS_NEW_SEEN_PREF = 'whatsNewSeen';

export type WhatsNewIcon = 'layout' | 'layers' | 'flag' | 'tag' | 'graph' | 'map' | 'grid';

export interface WhatsNewItem {
  icon: WhatsNewIcon;
  titleKey: string;
  bodyKey: string;
}

export const WHATS_NEW_ITEMS: WhatsNewItem[] = [
  { icon: 'layout', titleKey: 'whatsNew_look', bodyKey: 'whatsNew_lookBody' },
  { icon: 'layers', titleKey: 'whatsNew_viewer', bodyKey: 'whatsNew_viewerBody' },
  { icon: 'flag', titleKey: 'whatsNew_assets', bodyKey: 'whatsNew_assetsBody' },
  { icon: 'tag', titleKey: 'whatsNew_tickets', bodyKey: 'whatsNew_ticketsBody' },
  { icon: 'graph', titleKey: 'whatsNew_systems', bodyKey: 'whatsNew_systemsBody' },
  { icon: 'map', titleKey: 'whatsNew_plans', bodyKey: 'whatsNew_plansBody' },
  { icon: 'grid', titleKey: 'whatsNew_dashboard', bodyKey: 'whatsNew_dashboardBody' },
];

export interface ShouldShowWhatsNewInput {
  /** The person's saved preferences have loaded — before that, "not seen" is unknown, not false. */
  preferencesReady: boolean;
  seenReleaseId: unknown;
  /** Account creation time (ISO), when the server sent it. */
  userCreatedAt?: string | null;
  /** An admin looking through someone else's eyes ("View as") is not that person's first visit. */
  viewingAsSomeoneElse: boolean;
}

export function shouldShowWhatsNew({ preferencesReady, seenReleaseId, userCreatedAt, viewingAsSomeoneElse }: ShouldShowWhatsNewInput): boolean {
  if (!preferencesReady || viewingAsSomeoneElse) return false;
  if (seenReleaseId === WHATS_NEW_RELEASE.id) return false;
  const created = userCreatedAt ? Date.parse(userCreatedAt) : NaN;
  if (Number.isFinite(created) && created > Date.parse(WHATS_NEW_RELEASE.publishedAt)) return false;
  return true;
}
